export enum COUNTRY {
    AFG = 'AFG',
    ALA = 'ALA',
    ALB = 'ALB',
    DZA = 'DZA',
    ASM = 'ASM',
    AND = 'AND',
    AGO = 'AGO',
    AIA = 'AIA',
    ATA = 'ATA',
    ATG = 'ATG',
    ARG = 'ARG',
    ARM = 'ARM',
    ABW = 'ABW',
    AUS = 'AUS',
    AUT = 'AUT',
    AZE = 'AZE',
    BHS = 'BHS',
    BHR = 'BHR',
    BGD = 'BGD',
    BRB = 'BRB',
    BLR = 'BLR',
    BEL = 'BEL',
    BLZ = 'BLZ',
    BEN = 'BEN',
    BMU = 'BMU',
    BTN = 'BTN',
    BOL = 'BOL',
    BES = 'BES',
    BIH = 'BIH',
    BWA = 'BWA',
    BVT = 'BVT',
    BRA = 'BRA',
    IOT = 'IOT',
    BRN = 'BRN',
    BGR = 'BGR',
    BFA = 'BFA',
    BDI = 'BDI',
    CPV = 'CPV',
    KHM = 'KHM',
    CMR = 'CMR',
    CAN = 'CAN',
    CYM = 'CYM',
    CAF = 'CAF',
    TCD = 'TCD',
    CHL = 'CHL',
    CHN = 'CHN',
    CXR = 'CXR',
    CCK = 'CCK',
    COL = 'COL',
    COM = 'COM',
    COG = 'COG',
    COD = 'COD',
    COK = 'COK',
    CRI = 'CRI',
    CIV = 'CIV',
    HRV = 'HRV',
    CUB = 'CUB',
    CUW = 'CUW',
    CYP = 'CYP',
    CZE = 'CZE',
    DNK = 'DNK',
    DJI = 'DJI',
    DMA = 'DMA',
    DOM = 'DOM',
    ECU = 'ECU',
    EGY = 'EGY',
    SLV = 'SLV',
    GNQ = 'GNQ',
    ERI = 'ERI',
    EST = 'EST',
    SWZ = 'SWZ',
    ETH = 'ETH',
    FLK = 'FLK',
    FRO = 'FRO',
    FJI = 'FJI',
    FIN = 'FIN',
    FRA = 'FRA',
    GUF = 'GUF',
    PYF = 'PYF',
    ATF = 'ATF',
    GAB = 'GAB',
    GMB = 'GMB',
    GEO = 'GEO',
    DEU = 'DEU',
    GHA = 'GHA',
    GIB = 'GIB',
    GRC = 'GRC',
    GRL = 'GRL',
    GRD = 'GRD',
    GLP = 'GLP',
    GUM = 'GUM',
    GTM = 'GTM',
    GGY = 'GGY',
    GIN = 'GIN',
    GNB = 'GNB',
    GUY = 'GUY',
    HTI = 'HTI',
    HMD = 'HMD',
    VAT = 'VAT',
    HND = 'HND',
    HKG = 'HKG',
    HUN = 'HUN',
    ISL = 'ISL',
    IND = 'IND',
    IDN = 'IDN',
    IRN = 'IRN',
    IRQ = 'IRQ',
    IRL = 'IRL',
    IMN = 'IMN',
    ISR = 'ISR',
    ITA = 'ITA',
    JAM = 'JAM',
    JPN = 'JPN',
    JEY = 'JEY',
    JOR = 'JOR',
    KAZ = 'KAZ',
    KEN = 'KEN',
    KIR = 'KIR',
    PRK = 'PRK',
    KOR = 'KOR',
    KWT = 'KWT',
    KGZ = 'KGZ',
    LAO = 'LAO',
    LVA = 'LVA',
    LBN = 'LBN',
    LSO = 'LSO',
    LBR = 'LBR',
    LBY = 'LBY',
    LIE = 'LIE',
    LTU = 'LTU',
    LUX = 'LUX',
    MAC = 'MAC',
    MDG = 'MDG',
    MWI = 'MWI',
    MYS = 'MYS',
    MDV = 'MDV',
    MLI = 'MLI',
    MLT = 'MLT',
    MHL = 'MHL',
    MTQ = 'MTQ',
    MRT = 'MRT',
    MUS = 'MUS',
    MYT = 'MYT',
    MEX = 'MEX',
    FSM = 'FSM',
    MDA = 'MDA',
    MCO = 'MCO',
    MNG = 'MNG',
    MNE = 'MNE',
    MSR = 'MSR',
    MAR = 'MAR',
    MOZ = 'MOZ',
    MMR = 'MMR',
    NAM = 'NAM',
    NRU = 'NRU',
    NPL = 'NPL',
    NLD = 'NLD',
    NCL = 'NCL',
    NZL = 'NZL',
    NIC = 'NIC',
    NER = 'NER',
    NGA = 'NGA',
    NIU = 'NIU',
    NFK = 'NFK',
    MKD = 'MKD',
    MNP = 'MNP',
    NOR = 'NOR',
    OMN = 'OMN',
    PAK = 'PAK',
    PLW = 'PLW',
    PSE = 'PSE',
    PAN = 'PAN',
    PNG = 'PNG',
    PRY = 'PRY',
    PER = 'PER',
    PHL = 'PHL',
    PCN = 'PCN',
    POL = 'POL',
    PRT = 'PRT',
    PRI = 'PRI',
    QAT = 'QAT',
    REU = 'REU',
    ROU = 'ROU',
    RUS = 'RUS',
    RWA = 'RWA',
    BLM = 'BLM',
    SHN = 'SHN',
    KNA = 'KNA',
    LCA = 'LCA',
    MAF = 'MAF',
    SPM = 'SPM',
    VCT = 'VCT',
    WSM = 'WSM',
    SMR = 'SMR',
    STP = 'STP',
    SAU = 'SAU',
    SEN = 'SEN',
    SRB = 'SRB',
    SYC = 'SYC',
    SLE = 'SLE',
    SGP = 'SGP',
    SXM = 'SXM',
    SVK = 'SVK',
    SVN = 'SVN',
    SLB = 'SLB',
    SOM = 'SOM',
    ZAF = 'ZAF',
    SGS = 'SGS',
    SSD = 'SSD',
    ESP = 'ESP',
    LKA = 'LKA',
    SDN = 'SDN',
    SUR = 'SUR',
    SJM = 'SJM',
    SWE = 'SWE',
    CHE = 'CHE',
    SYR = 'SYR',
    TWN = 'TWN',
    TJK = 'TJK',
    TZA = 'TZA',
    THA = 'THA',
    TLS = 'TLS',
    TGO = 'TGO',
    TKL = 'TKL',
    TON = 'TON',
    TTO = 'TTO',
    TUN = 'TUN',
    TUR = 'TUR',
    TKM = 'TKM',
    TCA = 'TCA',
    TUV = 'TUV',
    UGA = 'UGA',
    UKR = 'UKR',
    ARE = 'ARE',
    GBR = 'GBR',
    USA = 'USA',
    UMI = 'UMI',
    URY = 'URY',
    UZB = 'UZB',
    VUT = 'VUT',
    VEN = 'VEN',
    VNM = 'VNM',
    VGB = 'VGB',
    VIR = 'VIR',
    WLF = 'WLF',
    ESH = 'ESH',
    YEM = 'YEM',
    ZMB = 'ZMB',
    ZWE = 'ZWE',
}
